import type { BatchCall } from '../../BatchCall.types';
import type { KernelClient } from '../../KernelClient.types';

export type PrepareUserOperationFromCallsParams = {
  calls: BatchCall[];
  kernelClient: KernelClient;
};

/**
 * Prepares a user operation from an array of calls
 * Replaces prepareUserOperationWithKernelClient to handle both single and batch transactions
 *
 * @param params.kernelClient - The kernel client to use for preparing the user operation
 * @param params.calls - Array of calls (can be single call or multiple calls)
 * @returns Promise resolving to the prepared user operation
 */
export const prepareUserOperationFromCalls = async ({
  kernelClient,
  calls,
}: PrepareUserOperationFromCallsParams) => {
  // Normalize calls to ensure data field exists
  const normalizedCalls = calls.map((call) => ({
    data: call.data ?? '0x',
    to: call.to,
    value: call.value,
  }));

  const callData = await kernelClient.account.encodeCalls(normalizedCalls);

  return kernelClient.prepareUserOperation({
    callData,
  });
};
